import { type FC, useMemo } from 'react';

import { staticPagesListRequest } from 'api/cms';
import Loader from 'components/Loader';
import Menu from 'components/Menu';
import { LoadingState } from 'utils/types';
import useRequest from 'utils/useRequest';

import type { PageGroupListProps } from './types';

const PageGroupList: FC<PageGroupListProps> = ({ group, dataId }) => {
  const { data, loading } = useRequest(
    () =>
      staticPagesListRequest({
        query: {
          group_name: group,
        },
      }),
    [group],
  );

  const items = useMemo(() => {
    if (!data) return [];
    return data.map(({ name, slug }) => ({
      id: slug,
      label: name,
      link: slug,
    }));
  }, [data]);

  if (loading === LoadingState.loading) {
    return <Loader />;
  }

  return <Menu items={items} dataId={dataId} />;
};

export default PageGroupList;
